// 🔑 ONE RATE, ONE FORMAT (the rate fix, Jesse 2026-10-25) — the browser's copy of backend/utils/rate.js.
// backend/test/rateFix.test.js runs both and holds them equal: the same 3-decimal format, the same buydown step, the
// same payment formula, so the card, the signed PDF, the LE and the CD can never show different figures.

const RATE_DP = 6;
export const POINT_STEP = 0.0025;   // 0.25% of rate per discount point

const round = (v, dp) => { const m = 10 ** dp; return Math.round((Number(v) + Number.EPSILON) * m) / m; };

export function toFraction(v) {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  return n > 1 ? n / 100 : n;
}

export function canonRate(v) { const f = toFraction(v); return f === null ? null : round(f, RATE_DP); }
export function ratePct(v) { const f = canonRate(v); return f === null ? null : round(f * 100, RATE_DP - 2); }
export function buydownRate(v, points) { const f = canonRate(v); if (f === null) return null; return canonRate(Math.max(0, f - (Number(points) || 0) * POINT_STEP)); }

export function formatRate(v) {
  const f = canonRate(v);
  if (f === null) return '—';
  return `${(f * 100).toFixed(3)}%`;
}

export function monthlyPI(loanAmount, v, n = 360) {
  const f = canonRate(v); const L = Number(loanAmount);
  if (f === null || !Number.isFinite(L) || L <= 0) return 0;
  const r = f / 12;
  return r > 0 ? (L * r * (1 + r) ** n) / ((1 + r) ** n - 1) : L / n;
}
